import React, { useState } from 'react';
import { Modal, Image } from 'react-bootstrap';
import CloseIcon from '../../assets/images/prompt_close_icon.svg';
import LevelLandscape from './LevelLandscape';
import LevelPortrait from './LevelPortrait';
import appProfile from '../../assets/images/level/appProfile.png';
import appCard from '../../assets/images/level/appCard.png';
import webappMobileProfile from '../../assets/images/level/webappMobileProfile.png';
import webappDesktopProfile from '../../assets/images/level/webappDesktopProfile.png';
import webappMobileCard from '../../assets/images/level/webappMobileCard.png';
import webappDesktopCard from '../../assets/images/level/webappDesktopCard.png';
import "./LevelBackgroundPreview.scss";


export const previewTypes = {
  appLandscape: "appLandscape",
  appPortrait: "appPortrait",
  webLandscape: "webLandscape",
  webPortrait: "webPortrait",
};

const getBackgroundImageConfig = (
  isApp,
  isLandscape,
  webAppIsMobile,
) => {
  if (isApp && isLandscape) {
    return {
      containerClassName: 'level-background-preview-app-container',
      imageClassName: 'level-background-preview-app-profile',
      image: appProfile
    };
  };
  if (isApp) {
    return {
      containerClassName: 'level-background-preview-app-container',
      imageClassName: 'level-background-preview-app-card',
      image: appCard
    };
  };
  if (isLandscape && webAppIsMobile) {
    return {
      containerClassName: 'level-background-preview-webapp-container',
      imageClassName: 'level-background-preview-webapp-mobile-profile',
      image: webappMobileProfile
    };
  }
  if (isLandscape) {
    return {
      containerClassName: 'level-background-preview-webapp-container',
      imageClassName: 'level-background-preview-webapp-desktop-profile',
      image: webappDesktopProfile
    };
  }
  if (webAppIsMobile) {
    return {
      containerClassName: 'level-background-preview-webapp-container',
      imageClassName: 'level-background-preview-webapp-mobile-card',
      image: webappMobileCard
    };
  };
  return {
    containerClassName: 'level-background-preview-webapp-container',
    imageClassName: 'level-background-preview-webapp-desktop-card',
    image: webappDesktopCard
  };
}

const LevelBackgroundPreview = ({
  show,
  setShow,
  previewType,
}) => {
  const isApp = [
    previewTypes.appLandscape,
    previewTypes.appPortrait,
  ].includes(previewType);

  const isLandscape = [
    previewTypes.appLandscape,
    previewTypes.webLandscape,
  ].includes(previewType);

  const [webAppIsMobile, setWebAppIsMobile] = useState(true);
  const backgroundImageConfig = getBackgroundImageConfig(isApp, isLandscape, webAppIsMobile);

  const onClose = () => {
    setShow(false);
    setWebAppIsMobile(true);
  }

  return (
    <Modal
      show={show}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop='static'
    >
      <Modal.Body className={`base-prompt-container level-background-color-preview ${backgroundImageConfig.containerClassName}`}>
        <Image
          src={CloseIcon}
          className="base-prompt-close-button"
          onClick={onClose}
        />
        <div className="first-section-title">Preview</div>
        {
          !isApp && (
            <div className='webapp-is-mobile-selector'>
              <div
                className={`webapp-responsive-item ${webAppIsMobile ? 'webapp-responsive-item-select' : ''}`}
                onClick={() => setWebAppIsMobile(true)}
              >
                <span>{"Mobile responsive (browser width < 1024px)"}</span>
              </div>
              <div
                className={`webapp-responsive-item ${!webAppIsMobile ? 'webapp-responsive-item-select' : ''}`}
                onClick={() => setWebAppIsMobile(false)}
              >
                <span>{"Desktop responsive (browser width >= 1024px)"}</span>
              </div>
            </div>
          )
        }
        <div className='level-background-image-container'>
          <img
            className={backgroundImageConfig.className}
            alt=""
            src={backgroundImageConfig.image}
          />
          <div>
            {
              isLandscape
                ? <LevelLandscape
                  isApp={isApp}
                  webAppIsMobile={webAppIsMobile}
                />
                : <LevelPortrait
                  isApp={isApp}
                  webAppIsMobile={webAppIsMobile}
                />
            }
          </div>
        </div>
      </Modal.Body>
    </Modal >
  )
}

export default LevelBackgroundPreview;
